interface TypingIndicatorProps {
  names: string[];
}

function joinNames(names: string[]): string {
  if (names.length === 0) return "";
  if (names.length === 1) return `${names[0]} pisze`;
  if (names.length === 2) return `${names[0]} i ${names[1]} piszą`;
  return `${names[0]}, ${names[1]} i ${names.length - 2} innych pisze`;
}

export function TypingIndicator({ names }: TypingIndicatorProps) {
  if (names.length === 0) return null;
  return (
    <div className="px-3 py-1 border-t border-gray-100 bg-gray-50 flex items-center gap-2 text-[11px] text-gray-600">
      <span className="flex items-end gap-0.5">
        <span className="dot dot-1 inline-block w-1.5 h-1.5 rounded-full bg-gray-500" />
        <span className="dot dot-2 inline-block w-1.5 h-1.5 rounded-full bg-gray-500" />
        <span className="dot dot-3 inline-block w-1.5 h-1.5 rounded-full bg-gray-500" />
      </span>
      <span>{joinNames(names)}…</span>
      <style>
        {`
          .dot { animation: gg-typing-bounce 1.2s infinite ease-in-out; transform-origin: center; }
          .dot-1 { animation-delay: 0s; }
          .dot-2 { animation-delay: 0.18s; }
          .dot-3 { animation-delay: 0.36s; }
          @keyframes gg-typing-bounce {
            0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
            30% { transform: translateY(-3px); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
}
